import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/report/getters";
import { actions } from "@/store/modules/report/actions";
import { mutations } from "@/store/modules/report/mutations";
import { IReportState, state } from "@/store/modules/report/state";

export const report: Module<IReportState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
